import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Chat from "./pages/Chat.jsx";
import Login from "./pages/Login.jsx";
import ChatBotSelection from "./pages/ChatBotSelection.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import Otpverification from "./pages/Otpverification.jsx";
import FrontLayout from './FrontLayout';
import NotFound from "./pages/NotFound.jsx";
import { useEffect, useState } from "react";

function App() {

  // const [darkMode, setDarkMode] = useState(() => {
  //   return localStorage.getItem("theme") === "dark";
  // });

  const [darkMode, setDarkMode] = useState("dark");

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/otp-verify" element={<Otpverification />} />

          <Route path="/" element={<FrontLayout cmp={ChatBotSelection} darkMode={darkMode} setDarkMode={setDarkMode} />} />
          <Route path="/chat" element={<FrontLayout cmp={Chat} darkMode={darkMode} setDarkMode={setDarkMode} />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
